var Backbone = require('backbone');
var _ = require('underscore');
var Obscura = require('backbone.obscura');

var SubtitleScope = require('../scopes/subtitle');
var STATUSES = SubtitleScope.VARIABLES.STATUSES;

var dispatcher = require('../dispatcher');

module.exports = Backbone.View.extend({
	model: new SubtitleScope.Model(),
	events: {
		'keyup p': 'updateSubTimer',
		'click p': 'pauseVideo',
	},
	movieModel: null,
	updateSubTimeout: null,
	filteredModel: null,
	sync: true,

	initialize: function (options) {
		_.extend(this, options);

		_.bindAll(this, 'displayCurrentSubtitle', 'modelFilter', 'updateSub', 'toggleSync', 'blackBg',
			'disableInlineEdit', 'enableInlineEdit', 'setFilteredCollection');

		this.$video = this.$('video')[0];

		this.setFilteredCollection();

		this.initEventListeners();

	},

	initEventListeners: function () {

		var updateCollectionEvents = [
			'EDIT_SUBTITLE',
			'ADD_SUBTITLE',
			'DELETE_SUBTITLE',
			'SPLIT_SUBTITLE',
			'MERGE_SUBTITLE',
			'UNDO_CHANGES',
			'REDO_CHANGES',
			'ITALIC',
			'BLACK_BG'
		];

		dispatcher.subscribe(updateCollectionEvents.join(' '), this.setFilteredCollection);

		dispatcher.subscribe(dispatcher.events.UPDATE_SUB_DISPLAY, function(model, forceDisplay) {
			this.displayCurrentSubtitle(model, forceDisplay);
		}.bind(this));

		dispatcher.subscribe(dispatcher.events.BLACK_BG, this.blackBg);

		dispatcher.subscribe(dispatcher.events.SYNC, this.toggleSync);

		dispatcher.subscribe(dispatcher.events.ENABLE_CONTROLS, this.enableInlineEdit);

		dispatcher.subscribe(dispatcher.events.DISABLE_CONTROLS, this.disableInlineEdit);
	},

	setFilteredCollection: function () {
		this.collection = new Obscura(this.movieModel.get('subtitle'));
	},

	toggleSync: function (val) {
		if (typeof val !== 'undefined') {
			this.sync = val;
			return;
		}

		this.sync = !this.sync;
	},

	enableInlineEdit: function () {
		this.$('.row1-subtitle, .row2-subtitle').prop('contenteditable', true);

	},

	disableInlineEdit: function () {
		this.$('.row1-subtitle, .row2-subtitle').prop('contenteditable', false);
	},

	// Helper function for text direction detection (same logic as in subtitle-editor.js)
	detectTextDirection: function(text) {
		if (!text || text.trim().length === 0) {
			return { direction: 'rtl' };
		}
		
		// Comprehensive RTL character detection
		// Hebrew: U+0590–U+05FF
		// Arabic: U+0600–U+06FF, U+0750–U+077F, U+08A0–U+08FF, U+FB50–U+FDFF, U+FE70–U+FEFF
		// Yiddish uses Hebrew characters: U+0590–U+05FF
		// Persian/Farsi uses Arabic script: U+0600–U+06FF
		// Urdu uses Arabic script: U+0600–U+06FF
		var rtlRegex = /[\u0590-\u05FF\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;
		
		if (rtlRegex.test(text)) {
			// If any RTL character is present (Hebrew, Arabic, Yiddish, Persian, Urdu, etc.)
			return { direction: 'rtl' };
		} else {
			// Pure LTR (English, etc.)
			return { direction: 'ltr' };
		}
	},

	// Apply text direction to a specific element (keep text centered)
	applyTextDirection: function($element, text) {
		var directionInfo = this.detectTextDirection(text);
		$element.css('direction', directionInfo.direction);
		// Keep text-align: center from CSS
	},

	displayCurrentSubtitle: function (model, forceDisplay) {
		var currentTime = this.$video.currentTime;
		var subtitleModel, status;

		this.currentFrame = Math.floor(currentTime * this.movieModel.get('frameRate') + 0.1);

		if (typeof forceDisplay === 'undefined') forceDisplay = false;

		if (model && !this.checkIfActiveFrame(model) && !forceDisplay) return false;

		if (!model) {
			model = this.collection.filterBy(this.modelFilter);

			//there is more then one result from collection filter
			if (model.length > 1) 
			{
				var temp = model.last();
				if(temp.get('status') != STATUSES.DELETED)
					model = model.last();
					else model = model.first();
			}
				
			else model = model.first();

			this.filteredModel = model;
		}

		status = model ? model.get('status') : STATUSES.DEFAULT;
		subtitleModel = model ? model.getCurrentModel() : null;

		if (subtitleModel && this.model &&
			subtitleModel.get('row1') === this.model.get('row1') &&
			subtitleModel.get('row2') === this.model.get('row2') &&
			subtitleModel.get('italic') === this.model.get('italic') &&
			status != STATUSES.DELETED && !forceDisplay)
			return;

		if (subtitleModel && status != STATUSES.DELETED) {
			var row1 = subtitleModel.get('row1') ? subtitleModel.get('row1') : '';
			var row2 = subtitleModel.get('row2') ? subtitleModel.get('row2') : '';

			this.$('.subtitle-display').show();

			if (row1 != '' && row2 === '') {
				this.$('.subtitle-display .row1-subtitle').html('');
				this.$('.subtitle-display .row2-subtitle').html(row1);
				// Apply direction detection to row1 content
				this.applyTextDirection(this.$('.subtitle-display .row2-subtitle'), row1);
			} else {
				this.$('.subtitle-display .row1-subtitle').html(row1);
				this.$('.subtitle-display .row2-subtitle').html(row2);
				// Apply direction detection to both rows
				this.applyTextDirection(this.$('.subtitle-display .row1-subtitle'), row1);
				this.applyTextDirection(this.$('.subtitle-display .row2-subtitle'), row2);
			}
			if (model.get('hasBox') || (localStorage.getItem("blackBg") == "true")) {
				this.$('.subtitle-display').addClass('black-bg');
			} else
				this.$('.subtitle-display').removeClass('black-bg');

			if (subtitleModel.get('italic')) this.$('.subtitle-display').addClass('italic');
			else this.$('.subtitle-display').removeClass('italic');

			this.model = new Backbone.Model(subtitleModel.toJSON());
			this.subtitleModel = model;
		} else if ((!subtitleModel || status == STATUSES.DELETED) && this.model) {

			this.$('.subtitle-display').hide();

			this.model = null;
		}

		var index = this.movieModel.get('subtitle').indexOf(model);

		if (this.sync && model) {
			dispatcher.emit(dispatcher.events.SELECT_SUBTITLE, index);
		}
	},

	modelFilter: function (model) {
		model = model.getCurrentModel();
		return this.checkIfActiveFrame(model) ? model : null;
	},

	checkIfActiveFrame: function (model) {
		var frameStart = model.get('frameStart');
		var frameEnd = model.get('frameEnd');

		return !!(frameStart <= this.currentFrame && this.currentFrame <= frameEnd);
	},

	blackBg: function () {
		if (!this.model.get('hasBox'))
			this.$('.subtitle-display').toggleClass('black-bg');
	},

	updateSubTimer: function (key) {
		clearInterval(this.updateSubTimeout);
		this.updateSubTimeout = setTimeout(this.updateSub(key), 700);
	},

	updateSub: function (key) {
		var newData = this.model.toJSON();
		var row1 = this.$('.subtitle-display .row1-subtitle').text();
		var row2 = this.$('.subtitle-display .row2-subtitle').text();

		if (newData['row1'] == row1 && newData['row2'] == row2) return;
		newData['row1'] = row1;
		newData['row2'] = row2;

		this.subtitleModel.addToStack(newData);

		dispatcher.emit(dispatcher.events.DB_UPDATE_SUBTITLE, {
			item: this.subtitleModel,
			force: true
		});
	},

	pauseVideo: function () {
		dispatcher.emit(dispatcher.events.PAUSE_VIDEO);
	}
});


// WEBPACK FOOTER //
// ./app/views/subtitle-display.js